__turbopack_context__.v({
  "paymentMethods": "KyP68G_paymentMethods",
  "skeletonCard": "KyP68G_skeletonCard",
});
